import { useState, useEffect } from "react";

const Sidebar = ({ sections }) => {
	const [activeSection, setActiveSection] = useState('s1');

	useEffect(() => {
		const handleScroll = () => {
			const sections = document.querySelectorAll('section');
			const scrollPosition = window.scrollY + 110;

			sections.forEach((section) => {
				const sectionTop = section.offsetTop;
				const sectionHeight = section.offsetHeight;

				if (scrollPosition >= sectionTop && scrollPosition < sectionTop + sectionHeight) {
					setActiveSection(section.getAttribute('id'));
				}
			});
		};

		window.addEventListener('scroll', handleScroll);

		return () => {
			window.removeEventListener('scroll', handleScroll);
		};
	}, []);

	const handleClick = (id) => {
		setActiveSection(id);
	};

	return (
		<div className='sticky top-[100px] h-fit hidden lg:block bg-transparent w-[256px] xl:w-[320px] 2xl:w-[384px]'>
			<nav className="p-[5px] lg:py-[60px] lg:px-[10px]">
				<ul className='md:space-y-3 lg:space-y-4 xl:space-y-6 2xl:space-y-8 sidebar-nav'>
					{sections.map(({ id, name }, i) => (
						<li
							key={i}
							className={`relative group ${activeSection === id
								? 'text-[#C94C67] font-bold'
								: 'text-gray-700 hover:font-bold'} transition duration-300 ease-in-out`}
						>
							{/* Link */}
							<a
								href={`#${id}`}
								onClick={() => handleClick(id)} // Handles click to set the active section
								className="relative z-10 block overflow-hidden pl-4" // Added padding-left for spacing
							>
								{name}
							</a>

							{/* Vertical line on the left */}
							<span
								className={`absolute top-0 left-0 h-full w-[2px] bg-[#C94C67] 
								${activeSection === id ? 'opacity-100' : 'opacity-0'} 
								group-hover:opacity-100 transition-all duration-300 ease-in-out`}
							></span>

							{/* Ripple effect */}
							<span className="absolute inset-0 bg-[#C94C67] opacity-0 group-hover:opacity-30 transform scale-50 group-hover:scale-100 transition duration-500 ease-in-out"></span>
						</li>
					))}
				</ul>
			</nav>
		</div>
	);
};

export default Sidebar;
